import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import ErrorMessage from '@kurtosys/ksys-app-components/dist/components/message/ErrorMessage';

export default InjectedStyledComponent(ErrorMessage, 'app', ['errorMessage']);